import React from 'react';
import '../styles/Trabajos.css';
import '../styles/index.css';
import '../styles/main.css';

const Footer = () => {
    return (
      <footer className="text-white mt-5">
        <div className="container my-5">
          <div className="row">
            <div className="col-sm-3">
              <h5>Dubbidan</h5>
            </div>
            <div className=" col-sm-3">
              <ul className="list-unstyled mx-auto">
                <li>
                  <a href="/TuRepositorio" className="text-white text-decoration-none">Tu Repositorio</a>
                </li>
                <li>
                  <a href="/Trabajos" className="text-white text-decoration-none">Trabajo</a>
                </li>
                <li>
                  <a href="/Actores" className="text-white text-decoration-none">Actores</a>
                </li>
              </ul>
            </div>
            <div className="col-sm-3">
              <ul className="list-unstyled mx-auto">
                <li>
                  <a href="/Contacto" className="text-white text-decoration-none">Contacto</a>
                </li>
                <li className="text-white">FAQ</li>
              </ul>
            </div>
            <div className="col-sm-3 marcas text-center">
              <span>
                <img src="/images/GooglePlay.png" alt="PlayStore" width="100px" />
              </span>
              <br />
              <span>
                <img src="/images/AppStore.png" alt="AppStore" width="100px" />
              </span>
            </div>
          </div>
  
          <div className="container my-5">
            <div className="d-flex justify-content-center">
              <p>© DubbiDan - 2025</p>
            </div>
          </div>
        </div>
      </footer>
    );
  };
  
  export default Footer;
